// extracted by mini-css-extract-plugin
export default {"section":"main_section__tmBxd","container":"main_container__s9MzI"};